<app-section #parentSection
             *ngIf="agreementsVisible"
             [title]="title"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [key]="key"
             class="calculation-agreements-section"
             [formConfig]="formConfig"
             [editMode]="true">

    <ng-template #section>
        <div *ngIf="agreementsVisible"
             class="agreements">
            <app-checkboxes-group #checkboxesGroup
                                  [config]="checkboxesGroupConfig"
                                  [fieldKeys]="checkboxesGroupFieldKeys"
                                  [bean]="bean"
                                  [formConfig]="formConfig"
                                  [formGroup]="formGroup"
                                  [formFactoryService]="formFactoryService"
                                  (checkboxChange)="onFieldChange($event)"
            >
            </app-checkboxes-group>

            <div *ngIf="requiredFieldInfoVisible"
                 class="agreements__required-field-info">
                {{ agreementsService.REQUIRED_SYMBOL }} {{ 'SHARED.requiredField' | translate }}
            </div>

            <div *ngIf="agreementsService.readonlyAgreementsAllowed"
                 class="agreements__readonly-agreements">
                <div *ngFor="let agreement of readonlyAgreements"
                     class="agreements__readonly-agreement"
                     [innerHTML]="agreementsService.getAgreementValue(agreement).value | safeHtml"
                ></div>
            </div>
        </div>
    </ng-template>
</app-section>
